import axios from "axios";

export const newGenKeyKuznechik = async () => {
    let response = await axios.get(`/kuznechik/newgenkey`);
    return response;
};

export const getKeyKuznechik = async () => {
    let response = await axios.get(`/kuznechik/getkey`);
    return response;
};

export const encryptKuznechik = async (encryption_mods, key, input_data) => {
    const dataReq = { encryption_mods, key, input_data: String(input_data) };
    const options = {
        async: true,
        crossDomain: true,
        data: dataReq,
    };
    return await axios.post(`/kuznechik/encrypt`, options);

};

export const decryptKuznechik = async (encryption_mods, key, input_data = String(input_data)) => {
    const dataReq = { encryption_mods, key, input_data: String(input_data) };
    const options = {
        async: true,
        crossDomain: true,
        data: dataReq,
    };
    return await axios.post(`/kuznechik/decrypt`, options);
};